import { OptionStateType } from '@kubit/web-ui-components/option/types';
import { commonStyles } from '../commonStyles';
import { ProductSelectorRowVariant } from '../variants';
export const getSelectorRowCustomStyles = (FOUNDATIONS) => ({
    [ProductSelectorRowVariant.CUSTOM]: {
        [OptionStateType.DEFAULT]: {
            ...commonStyles(FOUNDATIONS, {}),
        },
        [OptionStateType.FILLING]: {
            ...commonStyles(FOUNDATIONS, {}),
        },
        [OptionStateType.HOVER]: {
            ...commonStyles(FOUNDATIONS, {
                container: {
                    background_color: FOUNDATIONS.color_accent_hover_primary_bg_100,
                },
            }),
        },
        [OptionStateType.SELECTED]: {
            ...commonStyles(FOUNDATIONS, {
                container: {
                    background_color: FOUNDATIONS.color_accent_selected_bg_200,
                },
                radioButton: {
                    border_color: FOUNDATIONS.color_accent_selected_border_50,
                    border_width: FOUNDATIONS.border_100,
                },
                radioButtonIcon: {
                    background_color: FOUNDATIONS.color_accent_selected_icon_50,
                },
            }),
        },
        [OptionStateType.MULTIPLE_SELECTED]: {
            ...commonStyles(FOUNDATIONS, {
                container: {
                    background_color: FOUNDATIONS.color_accent_selected_bg_200,
                },
                radioButton: {
                    border_color: FOUNDATIONS.color_accent_selected_border_50,
                    border_width: FOUNDATIONS.border_100,
                },
                radioButtonIcon: {
                    background_color: FOUNDATIONS.color_accent_selected_icon_50,
                },
            }),
        },
        [OptionStateType.DISABLED]: {
            ...commonStyles(FOUNDATIONS, {
                container: {
                    background_color: FOUNDATIONS.color_accent_disabled_bg_100,
                },
                checkedIcon: {
                    color: FOUNDATIONS.color_accent_disabled_icon_50,
                },
                radioButton: {
                    border_color: FOUNDATIONS.color_accent_disabled_border_100,
                },
                radioButtonIcon: {
                    background_color: FOUNDATIONS.color_accent_disabled_icon_50,
                },
            }),
        },
        [OptionStateType.SELECTED_HOVER]: {
            ...commonStyles(FOUNDATIONS, {
                container: {
                    background_color: FOUNDATIONS.color_accent_hover_primary_bg_100,
                },
                radioButton: {
                    border_color: FOUNDATIONS.color_accent_selected_border_50,
                    border_width: FOUNDATIONS.border_100,
                },
                radioButtonIcon: {
                    background_color: FOUNDATIONS.color_accent_selected_icon_50,
                },
            }),
        },
        [OptionStateType.MULTIPLE_SELECTED_HOVER]: {
            ...commonStyles(FOUNDATIONS, {
                container: {
                    background_color: FOUNDATIONS.color_accent_selected_bg_200,
                },
                radioButton: {
                    border_color: FOUNDATIONS.color_accent_selected_border_50,
                    border_width: FOUNDATIONS.border_100,
                },
                radioButtonIcon: {
                    background_color: FOUNDATIONS.color_accent_selected_icon_50,
                },
            }),
        },
    },
});
//# sourceMappingURL=getSelectorRowCustom.js.map